import {VenueRow} from "./VenueRow";

export default VenueRow;